// extracted by mini-css-extract-plugin
export default {"cls1":"FormButtons-CancelButton_cls1__O5+x-","cls2":"FormButtons-CancelButton_cls2__m4Rlc FormButtons-CancelButton_cls1__O5+x-"};